

































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
@Component
export default class MaintainRecordHistory extends VueBase {
	dispatchList: Array<any> = []
	onClickLeft() {
		window.history.go(-1)
	}
	// 查询数据
	async searchDispatchList(vehicleNO: any) {
		await ajax
			.get('/api/maintainrecord/maintain-record-history/' + vehicleNO)
			.then((rep) => {
				console.log(rep)
				this.dispatchList.push(...rep.data.result)

			})
	}
	async created() {
		this.searchDispatchList(this.$route.query.vehicleNO)
	}
}
